import { GetRolesQuery, GetRolesQueryVariables, Role } from "@/graphql/types";
import { QueryOptions } from "@apollo/client";
import { InjectionKey, Ref } from "@vue/composition-api";

export const RoleKey: InjectionKey<Role> = Symbol();
export const IsNewKey: InjectionKey<Ref<boolean>> = Symbol();
export const ParentQueryKey: InjectionKey<
  QueryOptions<GetRolesQueryVariables, GetRolesQuery>
> = Symbol();
